import { GET_STORES } from '../action-types'
import api from 'Common/api'
import { handleServerError } from 'Common/utils'

export const getStores = () => async dispatch => {
  try {
    const res = await api.store.list()
    const stores = res.data.stores
    return dispatch({ type: GET_STORES, payload: stores })
  } catch (error) {
    console.log(error)
    return handleServerError(error)
  }
}
